import React, { useState } from 'react'
import { PlusCircleOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import './RelativeCard.scss'
import { ICustomerDetail_V2, ICustomerDetail_V4 } from '../../api/customer/customerApi'
import useToast from '../../hook/useToast'
import ModalDeleteManager from "../ModalDeleteManager";
import * as relativesApi from '../../api/relatives/relativesApi'
import * as businessApi from '../../api/business/businessApi'
import ModalAddContactCustomer from '../../pages/Customers/Modal/Business/ModalAddContactCustomer'
import ModalUpdateContactCustomer from '../../pages/Customers/Modal/Business/ModalUpdateContactCustomer'
import ItemContact from './ItemContact'
import { selectorInfoUser } from '../../store/slices/infoUserSlice'
import { useSelector } from 'react-redux'
interface Props {
  infoCustomer?: ICustomerDetail_V4;
  listBusinessCustomer?: businessApi.IListBusinessCustomers[]
  resultSubmitFormModalAddBusinessCustomer?: (iSsuccess: boolean, message?: string) => void
  resultSubmitFormModalUpdateBusinessCustomer?: (iSsuccess: boolean, message?: string) => void
  resultSubmitFormModalDeleteBusinessCustomer?: (iSsuccess: boolean, message?: string) => void
}

const BusinessCard: React.FC<Props> = ({
  infoCustomer, listBusinessCustomer,
  resultSubmitFormModalAddBusinessCustomer, resultSubmitFormModalUpdateBusinessCustomer, resultSubmitFormModalDeleteBusinessCustomer,
}) => {

  const pushToast = useToast();
  //
  const [isModalBusinessCustomerAdd, setIsModalBusinessCustomerAdd] = useState(false)
  const [isModalBusinessCustomerUpdate, setIsModalBusinessCustomerUpdate] = useState(false)
  const [isModalBusinessCustomerDelete, setIsModalBusinessCustomerDelete] = useState(false)

  const [openIndex, setOpenIndex] = useState<any>()
  const [idChoose, setIDChoose] = useState<number>()
  const [infoBusinessCustomer, setInfoBusinessCustomer] = useState<businessApi.IBusinessCustomers>()

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsModalBusinessCustomerAdd(false)
      resultSubmitFormModalAddBusinessCustomer?.(true, message)
    } else {
      resultSubmitFormModalAddBusinessCustomer?.(false, message)
    }
  }


  const gInfoContact = async (id: number) => {
    const result = await businessApi.getInfoCustomer(id)
    if (result?.status) {
      setInfoBusinessCustomer(result?.data)
      setIsModalBusinessCustomerUpdate(true)
    } else {
      pushToast(result?.message, "error")
    }
  }

  const onSubmitFormModalUpdateContacts = (iSsuccess: boolean, message?: string) => {

    if (iSsuccess) {
      setIsModalBusinessCustomerUpdate(false)
      resultSubmitFormModalUpdateBusinessCustomer?.(true, message)
    } else {
      resultSubmitFormModalUpdateBusinessCustomer?.(false, message)
    }
  }

  const openModalDelete = (id: number) => {
    setIDChoose(id)
    setIsModalBusinessCustomerDelete(true)
  }

  const onConfirmDelete = async () => {
    const result = await businessApi.deleteCustomer(Number(infoCustomer?.id), Number(idChoose))
    if (result?.status) {
      resultSubmitFormModalDeleteBusinessCustomer?.(true, result?.message)
    } else {
      resultSubmitFormModalDeleteBusinessCustomer?.(false, result?.message)
    }
    closeModalDeleter()
  }

  const closeModalDeleter = () => {
    setIDChoose(undefined)
    setIsModalBusinessCustomerDelete(false)
  }

  //DN


  return (
    <div className="relative-card">

      <ModalAddContactCustomer
        show={isModalBusinessCustomerAdd}
        infoCustomer={infoCustomer}

        modalClose={() => setIsModalBusinessCustomerAdd(false)}
        onSuccess={() => setIsModalBusinessCustomerAdd(false)}
        onSubmitFormModal={onSubmitFormModalAdd}
      />

      <ModalUpdateContactCustomer
        show={isModalBusinessCustomerUpdate}
        infoBusinessCustomer={infoBusinessCustomer}

        infoCustomer={infoCustomer}

        modalClose={() => setIsModalBusinessCustomerUpdate(false)}
        onSubmitFormModal={onSubmitFormModalUpdateContacts}
      />

      <ModalDeleteManager
        isOpen={isModalBusinessCustomerDelete}
        title="Bạn có chắc chắn xóa người liên hệ này"
        titleDelete="Xóa người liên hệ"
        content="Người liên hệ và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
        onConfirm={onConfirmDelete}
        closeModal={closeModalDeleter}
      />

      <div className={`order-history-card`}>
        <div className="title-ds">
          <div className="title">Danh sách người liên hệ</div>
          <Button
            icon={<PlusCircleOutlined />}
            iconPosition='end'
            className='rs-button rs-button--sm primary-outline'
            onClick={() => setIsModalBusinessCustomerAdd(true)}
          >Thêm mới</Button>
        </div>
        <div className='h-340-px overflow-y-scroll'>
          {
            listBusinessCustomer?.map((item, i) =>
              <ItemContact
                key={i}
                show={openIndex === i}
                showControl

                item={item}

                onToggle={() => handleToggle(i)}

                handleOpenModalUpdate={gInfoContact}
                handleOpenModalDele={openModalDelete}
              />
            )
          }
        </div>


      </div>
    </div>
  )
}

export default BusinessCard
